


































































































































































































import { Vue, Prop, Component } from "vue-property-decorator";
import {
  LearningRequest as ILearningRequest,
  LearningRequestStatusEnum
} from "@/api/models/learning-request";
import { learningType } from "@/plugins/learning-type";
import { availableStatuses, learningStatus } from "@/plugins/learning-status";
import { Employee as IEmployee } from "@/api/models/employee";
import api, { settingStorageApi } from "@/getinfo-api";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { LearningRequestChangeStatus as ILearningRequestChangeStatus } from "@/api/models/learning-request-change-status";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import CustomButton from "@/components/form/CustomButton.vue";
import Modal from "@/components/form/Modal.vue";
import ListenerInRequestList from "@/components/orders/ListenerInRequestList.vue";
import CourseRegistrationsTable from "@/components/courses/CourseRegistrationsTable.vue";
import { studentLimitModule } from "@/plugins/modules-detect";
import { getCurrentCompanyId } from "@/plugins/roles";

@Component({
  components: {
    CourseRegistrationsTable,
    ListenerInRequestList,
    Modal,
    CustomButton,
    CustomTableCol,
    CustomTableItem
  }
})
export default class OrderItemPreview extends Vue {
  modalId: string = this.generate();
  @Prop({ default: false }) contractTable!: boolean;
  @Prop({ default: false }) disableAction!: boolean;
  @Prop({ default: false }) isCheckable!: boolean;
  @Prop() request!: ILearningRequest & {
    payload: { course_listeners: string[] };
  };
  @Prop() index!: number;
  @Prop({ default: false }) isShowCopyAction?: boolean;
  isDisable: boolean = this.disableAction;
  status!: string;

  data() {
    return {
      status: undefined
    };
  }

  get isStudentLimitModule() {
    return studentLimitModule() && this.$store.state.studentLimit !== 0;
  }

  get isBlockAddStudent() {
    return (
      this.isStudentLimitModule &&
      this.$store.state.studentLimit - this.$store.state.studentAmount <
        this.request.users.length &&
      (this.request.status === LearningRequestStatusEnum.NotProcessed ||
        this.request.status === LearningRequestStatusEnum.WaitingPayment) &&
      this.request.resourceType !== "course2"
    );
  }

  get checkCourse() {
    return this.request.resourceType === "course"
      ? this.request.resourceId
      : undefined;
  }

  generate(): string {
    return Math.random()
      .toString(36)
      .substring(7);
  }

  created() {
    this.status = this.request.status;
  }

  getMaterialType(type: string) {
    return learningType(type);
  }

  getFormattedStatus(item: string) {
    return learningStatus(item);
  }

  get allStatuses() {
    return availableStatuses();
  }

  get companyId(): string {
    return getCurrentCompanyId();
  }

  async getStudentLimit() {
    if (this.companyId) {
      settingStorageApi.Company.getCompanySettings(this.companyId, [
        "studentLimit"
      ]).then(res => {
        //@ts-ignore
        this.$store.state.studentLimit = +res.data[0].value.amount;
      });
    }
  }
  async getStudentActive() {
    api.CourseApi.listenersCountGlobal(this.companyId).then(res => {
      this.$store.state.studentAmount = +res.data;
    });
  }

  changeStatus() {
    this.isDisable = true;
    let params: ILearningRequestChangeStatus = {
      //@ts-ignore
      status: this.status,
      handle: true
    };
    api.LearningRequestApi.changeStatus(this.request.id, params)
      .then((res: { data: ILearningRequest }) => {
        this.status = res.data.status;
        this.getStudentActive();
        this.getStudentLimit();
        if (
          res.data.status === "learning_finished" &&
          this.$store.getters["companyUtils/getIsFinishLearningWithEndLr"]
        ) {
          api.CourseApi.pass(
            res.data.resourceId,
            //@ts-ignore
            (res.data.payload.course_listeners as string[]).map(el => {
              return { listenerId: el, success: true };
            })
          );
        }

        this.$emit("changeStatus", [res.data.status, this.index]);

        this.$bvToast.toast(
          this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved),
          {
            variant: "success",
            title: this.$tc(this.$translate.Successful)
          }
        );
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.status = this.request.status;
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isDisable = false;
      });
  }

  goToProfile() {
    api.EmployeeApi.get(
      this.request.companyId,
      this.request.responsibleId
    ).then((res: { data: IEmployee }) => {
      this.$router.push({
        name: "userProfileView",
        params: { id: res.data.user.id }
      });
    });
  }
}
